import { useState } from "react";
import "./AppLayout.css";
import { Toolbar, Header } from "../../adminExportFiles";
import { Outlet } from "react-router-dom";

// <=1024px the sidebar can't stay permanently visible (there's no room),
// so it becomes an off-canvas drawer instead of the desktop icon-rail
// collapse - the same hamburger button drives both, picking behavior by
// viewport width at the moment it's pressed.
const MOBILE_BREAKPOINT = 1024;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleToggleNav = () => {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      setMobileNavOpen((open) => !open);
    } else {
      setCollapsed((c) => !c);
    }
  };

  return (
    <div>
        <div className="AppLayout">
          <Toolbar
            collapsed={collapsed}
            mobileOpen={mobileNavOpen}
            onToggleCollapse={handleToggleNav}
            onNavigate={() => setMobileNavOpen(false)}
          />
          {mobileNavOpen && (
            <div
              className="AppLayout__backdrop"
              onClick={() => setMobileNavOpen(false)}
              aria-hidden="true"
            />
          )}
          <div className={`layoutContent ${collapsed ? "layoutContent--collapsed" : ""}`}>
            <Header onToggleCollapse={handleToggleNav} />
            <div className="layoutContentMain">
              <Outlet />
            </div>
          </div>
        </div>
    </div>
  );
};

export default AppLayout;
